<template>
    <div class="d-flex my-4">
        <span class="span-filter">Filter</span>
        <select v-model="scope" @change="search" class="form-control custom-select">
            <option value="canada-wide">Canada Wide</option>
            <option value="current-location">Search Near Me</option>
        </select>
    </div>
</template>

<script>
export default {
    name: "SearchFilter",
    data() {
        return {
            scope: new URLSearchParams(document.location.search).get("scope") ?? "canada-wide",
            query: new URLSearchParams(document.location.search).get("query") ?? ""
        }
    },
    computed: {
        queryString: function () {
            // TS 2021-05-28
            // The query param is currently set upon initial load.
            // If you change the search box value, then come back to change scope filter -- it will use the previous value.
            // We can get around this restriction by creating a global store for the search box query, if this is necessary.
            return "?scope=" + this.scope +
                "&query=" + this.query;
        }
    },
    methods: {
        search: function () {
            if (this.query)
                window.location.href = "/search" + this.queryString;
        },
    }
}
</script>

<style scoped>
.span-filter {
    font-size: 12pt;
    font-weight: bold;
    padding: 0.3rem 1rem;
}

select.form-control {
    max-width: 10rem;
}
</style>
